import { render } from "./ProducerForm.vue?vue&type=template&id=4a74599e"
import script from "./ProducerForm.vue?vue&type=script&lang=js"
export * from "./ProducerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__